import { render } from "./modal.vue?vue&type=template&id=567147e6&lang=pug"
import script from "./modal.vue?vue&type=script&setup=true&lang=js"
export * from "./modal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__